module.exports = __webpack_public_path__ + "media/audio24.3079be36.mp3";